import React from "react";
import "./Settings.css";
import FullPageLoading from "../../components/FullPageLoading/FullPageLoading";
import { useSettings } from "../../customHooks/Settings/useSettings";

const Settings = () => {
  const { formData, errors, handleChange, handleBlur, handleSubmit, loader, handleCancel } =
    useSettings();

  return (
    <>
      {!loader ? (
        <>
          <div className="container-fluid py-4">
            <div className="row">
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h1 className="font-semibold text-lg"> Settings</h1>
                </div>

                <div>
                  <div className="row">
                    <div className="col-12">
                      <div className="card mb-4">
                        <div
                          className="card-header"
                          style={{ backgroundColor: "#E3E7EA" }}
                        >
                          <h5 className="mb-0">
                            <b>Settings Details</b>
                          </h5>
                        </div>
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-12 d-flex align-items-center mb-3">
                              <div className="col-md-2">
                                <label
                                  htmlFor="logo"
                                  className="form-label mb-0"
                                >
                                  Logo
                                </label>
                                <input
                                  type="file"
                                  accept="image/*"
                                  className="form-control form-control-sm"
                                  id="logo"
                                  name="logo"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  style={{ width: "150px" }}
                                />
                                {/* ✅ Show image preview if it's a URL */}
                                {formData.logo &&
                                  typeof formData.logo === "string" && (
                                    <div className="mt-2">
                                      <img
                                        src={formData.logo}
                                        alt="Uploaded Logo"
                                        style={{
                                          width: "100px",
                                          height: "auto",
                                          objectFit: "contain",
                                        }}
                                      />
                                    </div>
                                  )}
                                {/* ✅ Optional: Show preview if a new file is selected */}
                                {formData.logo &&
                                  typeof formData.logo === "object" && (
                                    <div className="mt-2">
                                      <img
                                        src={URL.createObjectURL(formData.logo)}
                                        alt="New Logo Preview"
                                        style={{
                                          width: "100px",
                                          height: "auto",
                                          objectFit: "contain",
                                        }}
                                      />
                                    </div>
                                  )}
                                {errors.logo && (
                                  <div className="error-message">
                                    {errors.logo}
                                  </div>
                                )}
                              </div>

                              <div className="col-md-2">
                                <label
                                  htmlFor="title"
                                  className="form-label mb-0"
                                >
                                  Title
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="title"
                                  name="title"
                                  value={formData.title}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="Enter title"
                                />
                                {errors.title && (
                                  <div className="error-message">
                                    {errors.title}
                                  </div>
                                )}
                              </div>
                              <div className="col-md-4">
                                <label
                                  htmlFor="bppId"
                                  className="form-label mb-0"
                                >
                                  Bpp Id
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="bppId"
                                  name="bppId"
                                  value={formData.bppId}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="Enter Bpp Id"
                                />
                                {errors.bppId && (
                                  <div className="error-message">
                                    {errors.bppId}
                                  </div>
                                )}
                              </div>
                              <div className="col-md-4">
                                <label
                                  htmlFor="bppUrl"
                                  className="form-label mb-0"
                                >
                                  Bpp URL
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="bppUrl"
                                  name="bppUrl"
                                  value={formData.bppUrl}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="Enter Bpp URL"
                                />
                                {errors.bppUrl && (
                                  <div className="error-message">
                                    {errors.bppUrl}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="col-md-12 mb-3">
                              <label className="form-label">
                                <span style={{ fontSize: "16px" }}>
                                  Contact Info
                                </span>
                              </label>
                              <div className="row">
                                <div className="col-md-4 mb-3">
                                  <label
                                    htmlFor="storeEmail"
                                    className="form-label"
                                  >
                                    Store Email
                                  </label>
                                  <input
                                    type="email"
                                    className="form-control"
                                    id="storeEmail"
                                    name="storeEmail"
                                    value={formData.storeEmail || ""}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="Enter store email"
                                  />
                                  {errors.storeEmail && (
                                    <div className="error-message">
                                      {errors.storeEmail}
                                    </div>
                                  )}
                                </div>
                                <div className="col-md-4 mb-3">
                                  <label
                                    htmlFor="storeContactNo"
                                    className="form-label"
                                  >
                                    Store Contact No.
                                  </label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    id="storeContactNo"
                                    name="storeContactNo"
                                    value={formData.storeContactNo || ""}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="Enter store contact number"
                                  />
                                  {errors.storeContactNo && (
                                    <div className="error-message">
                                      {errors.storeContactNo}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 mb-3">
                              <label htmlFor="address" className="form-label">
                                <span style={{ fontSize: "16px" }}>
                                  Address
                                </span>
                              </label>
                              <div className="row">
                                <div className="col-md-2 mb-3">
                                  <label
                                    htmlFor="locality"
                                    className="form-label"
                                  >
                                    Locality
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="locality"
                                    name="locality"
                                    value={formData.locality || ""}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="Enter locality"
                                  />
                                  {errors.locality && (
                                    <div className="error-message">
                                      {errors.locality}
                                    </div>
                                  )}
                                </div>
                                <div className="col-md-2 mb-3">
                                  <label
                                    htmlFor="street"
                                    className="form-label"
                                  >
                                    Street
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="street"
                                    name="street"
                                    value={formData.street || ""}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="Enter street"
                                  />
                                  {errors.street && (
                                    <div className="error-message">
                                      {errors.street}
                                    </div>
                                  )}
                                </div>
                                <div className="col-md-2 mb-3">
                                  <label htmlFor="city" className="form-label">
                                    City
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="city"
                                    name="city"
                                    value={formData.city || ""}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="Enter city"
                                  />
                                  {errors.city && (
                                    <div className="error-message">
                                      {errors.city}
                                    </div>
                                  )}
                                </div>
                                <div className="col-md-2 mb-3">
                                  <label htmlFor="state" className="form-label">
                                    State
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="state"
                                    name="state"
                                    value={formData.state || ""}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="Enter state"
                                  />
                                  {errors.state && (
                                    <div className="error-message">
                                      {errors.state}
                                    </div>
                                  )}
                                </div>
                                <div className="col-md-2 mb-3">
                                  <label
                                    htmlFor="country"
                                    className="form-label"
                                  >
                                    Country
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="country"
                                    name="country"
                                    value={formData.country || ""}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="Enter country"
                                  />
                                  {errors.country && (
                                    <div className="error-message">
                                      {errors.country}
                                    </div>
                                  )}
                                </div>
                                <div className="col-md-2 mb-3">
                                  <label
                                    htmlFor="pincode"
                                    className="form-label"
                                  >
                                    Area Code
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="pincode"
                                    name="pincode"
                                    value={formData.pincode || ""}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="Enter area code"
                                  />
                                  {errors.pincode && (
                                    <div className="error-message">
                                      {errors.pincode}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>

                            {/* Short Description */}
                            <div className="col-md-12 mb-3">
                              <label
                                htmlFor="shortDescription"
                                className="form-label"
                              >
                                Short Description
                              </label>
                              <textarea
                                className="form-control"
                                id="shortDescription"
                                name="shortDescription"
                                rows="3"
                                value={formData.shortDescription || ""}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter short description"
                              />
                              {errors.shortDescription && (
                                <div className="error-message">
                                  {errors.shortDescription}
                                </div>
                              )}
                            </div>

                            {/* Long Description */}
                            <div className="col-md-12 mb-3">
                              <label
                                htmlFor="longDescription"
                                className="form-label"
                              >
                                Long Description
                              </label>
                              <textarea
                                className="form-control"
                                id="longDescription"
                                name="longDescription"
                                rows="4"
                                value={formData.longDescription || ""}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter long description"
                              />
                              {errors.longDescription && (
                                <div className="error-message">
                                  {errors.longDescription}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Business Details Section */}
                    <div className="col-12">
                      <div className="card mb-4">
                        <div
                          className="card-header"
                          style={{ backgroundColor: "#E3E7EA" }}
                        >
                          <h5 className="mb-0">
                            <b>Business Details</b>
                          </h5>
                        </div>
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-4">
                              <div className="mb-3">
                                <label
                                  htmlFor="authorizedPersonName"
                                  className="form-label"
                                >
                                  Authorized Person Name
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="authorizedPersonName"
                                  name="authorizedPersonName"
                                  value={formData.authorizedPersonName || ""}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="Enter authorized person name"
                                />
                                {errors.authorizedPersonName && (
                                  <div className="error-message">
                                    {errors.authorizedPersonName}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="mb-3">
                                <label
                                  htmlFor="dateOfIncorporation"
                                  className="form-label"
                                >
                                  Date of Incorporation
                                </label>
                                <input
                                  type="date"
                                  className="form-control"
                                  id="dateOfIncorporation"
                                  name="dateOfIncorporation"
                                  value={formData.dateOfIncorporation || ""}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                />
                                {errors.dateOfIncorporation && (
                                  <div className="error-message">
                                    {errors.dateOfIncorporation}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="mb-3">
                                <label
                                  htmlFor="panNumber"
                                  className="form-label"
                                >
                                  PAN Number
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="panNumber"
                                  name="panNumber"
                                  value={formData.panNumber || ""}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="Enter PAN number"
                                />
                                {errors.panNumber && (
                                  <div className="error-message">
                                    {errors.panNumber}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="row mt-4">
                            <div className="col-md-4">
                              <div className="mb-3">
                                <label
                                  htmlFor="nameAsPerPAN"
                                  className="form-label"
                                >
                                  Name as Per PAN
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="nameAsPerPAN"
                                  name="nameAsPerPAN"
                                  value={formData.nameAsPerPAN || ""}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="Enter name as per PAN"
                                />
                                {errors.nameAsPerPAN && (
                                  <div className="error-message">
                                    {errors.nameAsPerPAN}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="mb-3">
                                <label
                                  htmlFor="gstNumber"
                                  className="form-label"
                                >
                                  GST Number
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="gstNumber"
                                  name="gstNumber"
                                  value={formData.gstNumber || ""}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="Enter GST number"
                                />
                                {errors.gstNumber && (
                                  <div className="error-message">
                                    {errors.gstNumber}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Bank Details Section */}
                    <div className="col-12">
                      <div className="card mb-4">
                        <div
                          className="card-header"
                          style={{ backgroundColor: "#E3E7EA" }}
                        >
                          <h5 className="mb-0">
                            <b>Bank Details</b>
                          </h5>
                        </div>
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-4">
                              <div className="mb-3">
                                <label
                                  htmlFor="beneficiaryName"
                                  className="form-label"
                                >
                                  Beneficiary Name
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="beneficiaryName"
                                  name="beneficiaryName"
                                  value={formData.beneficiaryName || ""}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="Enter beneficiary name"
                                />
                                {errors.beneficiaryName && (
                                  <div className="error-message">
                                    {errors.beneficiaryName}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="mb-3">
                                <label
                                  htmlFor="accountNumber"
                                  className="form-label"
                                >
                                  Account Number
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="accountNumber"
                                  name="accountNumber"
                                  value={formData.accountNumber || ""}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="Enter account number"
                                />
                                {errors.accountNumber && (
                                  <div className="error-message">
                                    {errors.accountNumber}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="mb-3">
                                <label
                                  htmlFor="ifscCode"
                                  className="form-label"
                                >
                                  IFSC Code
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="ifscCode"
                                  name="ifscCode"
                                  value={formData.ifscCode || ""}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="Enter IFSC code"
                                />
                                {errors.ifscCode && (
                                  <div className="error-message">
                                    {errors.ifscCode}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="row mt-4">
                            <div className="col-md-4">
                              <div className="mb-3">
                                <label
                                  htmlFor="bankName"
                                  className="form-label"
                                >
                                  Bank Name
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="bankName"
                                  name="bankName"
                                  value={formData.bankName || ""}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="Enter bank name"
                                />
                                {errors.bankName && (
                                  <div className="error-message">
                                    {errors.bankName}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="mb-3">
                                <label htmlFor="branch" className="form-label">
                                  Branch
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="branch"
                                  name="branch"
                                  value={formData.branch || ""}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="Enter branch name"
                                />
                                {errors.branch && (
                                  <div className="error-message">
                                    {errors.branch}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12">
                      <div className="d-flex justify-content-end gap-2">
                        <button type="button" className="btn btn-secondary"  onClick={handleCancel}>
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleSubmit}
                        >
                          Save Settings
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <FullPageLoading />
        </>
      )}
    </>
  );
};

export default Settings;
